/**
 * Created by m.igrachev on 3/2/2018.
 */
import React from "react";
import PropTypes from "prop-types";
import CommonUtils from "@tinqin/tinqin-utils/src/common";
import typeOfOperand from "@tinqin/tinqin-utils/src/base/typeOfOperand";
import documentedProps from "./documentation/FocusableDocumentedProps";

export default class Focusable extends React.Component {
    //IMPORTANT: Is is strictly forbidden to do "setState" in this class, since it is designed to
    //IMPORTANT: only be extended and not directly used. React will not work properly if we setState here!
    constructor(props) {
        super(props);

        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
    }

    getComponentValuePropertyName() {
        //Note: If we want come up with more value names we are supposed to add them here!
        if (typeof this.state.selection !== "undefined") {
            return "selection";
        } else if (typeof this.state.files !== "undefined") {
            return "files";
        }

        return "value";
    }

    onFocus(event, consumerCallback) {
        //Bad assumption here that value will always be called value.
        //However this is always the case, so for now we will trust it!
        let value = this.getComponentValuePropertyName();
        let callback = consumerCallback || this.props.onFocus;
        //Note: While we are on already on focus, we want to ignore further focus events.
        //Note: The value we want to keep here is the value of the first focus, up to the blur.
        if (this.focusInValue === undefined) {
            if (typeOfOperand(this.state[value]) === "object") {
                this.focusInValue = Object.assign({}, this.state[value]);
            } else if (typeOfOperand(this.state[value]) === "array") {
                this.focusInValue = Array.from(this.state[value]);
            } else {
                this.focusInValue = this.state[value];
            }

            //Note: Multiple focusing after one blur must result in only one callback call!
            if (callback) {
                callback(this.state);
            }
        }
    }

    didValueChangedSinceLastFocus() {
        //Note: We assume here that we can always resolve the value name!
        let value = this.getComponentValuePropertyName();
        return !CommonUtils.isEqual(this.focusInValue, this.state[value]);
    }

    onBlur(event, consumerCallback) {
        //This is simple default realization for onBlur. In most cases we will want to override it.
        //In some cases though we might want to use the default!
        let callback = consumerCallback || this.props.onBlur;
        let smartBlur = this.props.smartBlur !== false; //Note: true by default
        if (callback && (this.didValueChangedSinceLastFocus() || !smartBlur)) {
            callback(this.state);
        }
        this.focusInValue = undefined;
    }
}

Focusable.propTypes = {
    smartBlur: PropTypes.bool,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func
};

Focusable.documentedProps = documentedProps;

Focusable.displayName = "Focusable";
